import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbWysiwygModule } from 'mdb-wysiwyg';
import { MdbSortableModule } from 'mdb-sortable';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { AgmCoreModule } from '@agm/core';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { SearchPipe } from '../custom-pipe/SearchPipe';
import { GetTypePipe } from '../custom-pipe/GetTypePipe';
import { KeysPipe } from '../custom-pipe/KeysPipe';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '../custom-pipe/TruncatePipe';
@NgModule({
    declarations: [
        KeysPipe,
        GetTypePipe,
        SearchPipe,
        TruncatePipe
    ],
    imports: [
        CommonModule,
        MDBBootstrapModulesPro.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD-LC1IRlirpLm8n6GjaCLTsR9cTJ_NT68',
            libraries: ['places']
          }),
        MdbFileUploadModule,
        MdbSortableModule,
        MdbWysiwygModule,
        AngularFontAwesomeModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,

    ],
    exports: [
        MDBBootstrapModulesPro,
        AgmCoreModule,
        MdbFileUploadModule,
        MdbSortableModule,
        MdbWysiwygModule,
        AngularFontAwesomeModule,
        KeysPipe,
        GetTypePipe,
        SearchPipe,
        TruncatePipe,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,

    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class MdbGlobalModule { }
